import { ROLES } from "../constants/access.constant";

export const hasPermission = (user, permission) => {
  return !!user && Array.isArray(user.permissions) && user.permissions.includes(permission);
};

export const hasAllPermissions = (user, permissions = []) => {
  if (!user || !Array.isArray(user.permissions)) return false;
  if (permissions.length === 0) return false;
  return permissions.every((permission) => user.permissions.includes(permission));
};

export const hasAnyPermission = (user, permissions = []) => {
  if (!user || !Array.isArray(user.permissions)) return false;
  if (permissions.length === 0) return false;
  return permissions.some((permission) => user.permissions.includes(permission));
};

export const hasAdminPriviledge =  (user) => {
  if (!user || !Array.isArray(user.permissions) || !user.role) return false;
  return user.role === ROLES.ADMIN;
}

export const hasRole =  (user, roles=[]) => {
  if (!user || !Array.isArray(user.permissions) || !Array.isArray(roles) || !user.role) return false;
  if (roles.length === 0) return false;
  return roles.every((role) => user.role.includes(role));
}